import LegalPageLayout from './LegalPageLayout';

export default function CookiePolicyPage() {
  return (
    <LegalPageLayout title="Çerez Politikası">
      <p>
        Bu politika, web sitemizde kullanılan çerez türlerini, kullanım amaçlarını ve çerez tercihlerinizi nasıl yönetebileceğinizi
        açıklar.
      </p>

      <h2>1. Çerez Nedir?</h2>
      <p>
        Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcınıza kaydedilen küçük metin dosyalarıdır. Site deneyimini
        geliştirmek, tercihleri hatırlamak ve performans ölçümü yapmak için kullanılır.
      </p>

      <h2>2. Kullandığımız Çerez Türleri</h2>
      <ul>
        <li><strong>Zorunlu Çerezler:</strong> Site işlevlerinin çalışması için gereklidir.</li>
        <li><strong>Performans Çerezleri:</strong> Site kullanımını analiz ederek iyileştirme yapmamıza yardımcı olur.</li>
        <li><strong>Fonksiyonel Çerezler:</strong> Dil, tema ve tercihlerinizi hatırlar.</li>
        <li><strong>Pazarlama Çerezleri:</strong> Kampanya ve iletişim performansının ölçülmesi için kullanılabilir.</li>
      </ul>

      <h2>3. Çerezlerin Kullanım Amaçları</h2>
      <ul>
        <li>Oturum ve güvenlik süreçlerini yönetmek</li>
        <li>Kullanıcı deneyimini kişiselleştirmek</li>
        <li>Sayfa performansını ve etkileşimi ölçmek</li>
        <li>Teklif ve başvuru süreçlerini optimize etmek</li>
      </ul>

      <h2 id="cerez-yonetimi">4. Çerez Tercihleri Nasıl Yönetilir?</h2>
      <p>
        Çerez ayarlarınızı tarayıcı tercihleri üzerinden dilediğiniz zaman değiştirebilir veya silebilirsiniz. Bazı çerezleri devre dışı
        bırakmanız halinde sitenin belirli işlevleri sınırlı çalışabilir.
      </p>

      <h2>5. Üçüncü Taraf Çerezler</h2>
      <p>
        Sitemizde analiz ve teknik altyapı amaçlı üçüncü taraf servislerin çerezleri kullanılabilir. Bu servislerin veri işleme
        koşulları kendi gizlilik politikalarına tabidir.
      </p>
    </LegalPageLayout>
  );
}
